import { FileText, ExternalLink } from 'lucide-react';
import { GRAD, fg, fgMuted, surface, border, muted } from './profile-shared';
import { openFileUrl } from '@/hooks/use-file-open';

type Doc = { id: string; name: string; url: string; fileType: string; fileSize: string; createdAt: string };

interface DocumentsTabProps {
  docs: Doc[];
  isAdmin: boolean;
}

export default function DocumentsTab({ docs, isAdmin }: DocumentsTabProps) {
  return (
    <div className="rounded-2xl p-5" style={{ background: surface, border: `1px solid ${border}` }}>
      <div className="mb-4 flex items-center gap-2">
        <FileText size={16} style={{ color: GRAD }} />
        <h2 className="text-sm font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: fg }}>
          Shared Documents
        </h2>
      </div>

      {docs.length === 0 ? (
        <div className="flex flex-col items-center gap-3 py-12 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl"
            style={{ background: 'hsla(243,75%,59%,0.1)' }}>
            <FileText size={24} style={{ color: GRAD }} />
          </div>
          <p className="text-sm font-semibold" style={{ color: fg, fontFamily: 'Outfit, sans-serif' }}>No documents yet</p>
          <p className="max-w-xs text-xs" style={{ color: fgMuted, fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
            {isAdmin ? 'Documents shared with you by your clients will appear here.' : 'Documents shared with you by your consultant will appear here.'}
          </p>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {docs.map(doc => (
            <button
              key={doc.id}
              type="button"
              onClick={() => openFileUrl(doc.url)}
              className="flex w-full items-center gap-3 rounded-xl px-4 py-3 text-left transition-all hover:opacity-80"
              style={{ background: muted, border: `1px solid ${border}` }}>
              <FileText size={16} style={{ color: GRAD, flexShrink: 0 }} />
              <div className="flex-1 min-w-0">
                <p className="truncate text-sm font-semibold" style={{ color: fg, fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                  {doc.name}
                </p>
                <p className="text-xs" style={{ color: fgMuted, fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                  {doc.fileType} · {doc.fileSize}
                </p>
              </div>
              <ExternalLink size={13} style={{ color: fgMuted, flexShrink: 0 }} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
